module.exports = __webpack_public_path__ + "static/media/collective-member-smiling-and-enjoying-single-cask-whisky-caskshare.afabc817.jpg";